export default __webpack_public_path__ + "static/media/Image-19.ed676656.png";